import React, { Component } from 'react';

import './Workers.css';

import en from '../../../language/en/Workers.json';
import es from '../../../language/es/Workers.json';

import { Link } from 'react-router-dom';
import VerticalTabs from './VerticalTabs';
import { Paper } from '@material-ui/core';
// import HorizontalLinearStepper from './Stepper';

class Workers extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
            },
            // workers: []
        };

        // alert('por qué no hace scrollTo Top?');
        window.scrollTo(0, 1);
	}
	
	componentDidMount() {
		/* let url = `${config.apiBaseUrl}/trabajador`;

		//Obteniendo todos los trabajadores del centro
		fetch(url)
		.then(
			res => {
				return res.json();
			}
		)
		.then(
			data => {
				//console.log('data = ', data);
				this.setState({
					workers: data
				});
			}
		)
		.catch(
			err => {
				console.log("error ", err);
			}
		); */
	}

	render() {
	  	const lang = this.state.config.lang;
        const selectedLanguage = (this.props.lang==='en')? lang.en: lang.es;
		
		/* let childsId = [];
        const workers = this.state.workers.map((worker, i) => {
			childsId[i] = worker.id;
			return (
				<tr key={ i }>
					<td>{ worker.id }</td>
					<td>{ worker.nombre } { worker.apellidos }</td>
					<td>{ worker.plaza }</td>
					<td>{ worker.departamento }</td>
					<td>{ worker.estado }</td>
					<td>
						<Link className="btn btn-sm blue" to={{ 
							pathname: '/cmp/worker/' + worker.id, 
							state: {
								childsId 
							}
							}}>
							<i className="fa fa-search-plus"></i>
							Ver
						</Link>
					</td>
				</tr>
			)
		}); */

	    return (
            <div className="Workers">
                <div className="container">
                    <div className="heading">
                        <h2><strong>Todos los trabajadores</strong></h2>
                    </div>
                    <div className="row">
						<Paper elevation={4} style={{margin: '8px 0', padding: '8px'}}>
							<VerticalTabs />
						</Paper>

						{/* <HorizontalLinearStepper /> */}

						{/* <div className="portlet light">
								<div className="portlet-title tabbable-line">
									<div className="caption caption-md">
										<i className="icon-globe theme-font hide"></i>
										<span className="caption-subject font-blue-hoki bold uppercase">Trabajadores</span>
									</div>
									<div className="actions">
										<Link className="btn btn-icon-only btn-default btn-sm fullscreen" to="javascript:;" data-original-title="" title="">
										</Link>
									</div>																			
								</div>
								<div className="portlet-body">

									<table className="table table-striped table-borderedx table-hoVer table-condensedx table-responsivex">
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Nombre y Apellidos</th>
                                                <th>Plaza</th>
                                                <th>Departamento</th>
                                                <th>Estado</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { workers }
                                        </tbody>
                                    </table>												
								</div>
							</div> */}

                    </div>
                </div>
            </div>
	    )
  	}
}

export default Workers;